// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"UiError_compWrap__1Cww_","error":"UiError_error__kx0_J","paragraph":"UiError_paragraph__2wBkE","footer":"UiError_footer__wBduD"};